/* SoccerDrop — fiche produit */
(function () {
function initSdp(root) {
if (root.dataset.ready) return;
root.dataset.ready = '1';
var PH = root.getAttribute('data-ph') || '';

    
    var D = {};
    try { D = JSON.parse(root.querySelector('[data-sdp-json]').textContent); } catch (e) { return; }
    var V = D.variants || [], P = D.pos || {};
    var $ = function (q) { return root.querySelector(q); };
    var $$ = function (q) { return Array.prototype.slice.call(root.querySelectorAll(q)); };
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function money(cents) {
      var n = (cents / 100).toFixed(2).replace('.', ',');
      return n + ' €';
    }

    /* ---------- état ---------- */
    var st = { size: null, version: null, floc: false, patch: '', patchPrice: 0 };
    var firstVer = $('[data-sdp-opt="' + P.version + '"][aria-pressed="true"]');
    if (P.version && firstVer) st.version = firstVer.getAttribute('data-value');

    function find(sizeVal) {
      return V.filter(function (v) {
        if (P.size && v.o[P.size - 1] !== (sizeVal !== undefined ? sizeVal : st.size)) return false;
        if (P.version && st.version && v.o[P.version - 1] !== st.version) return false;
        if (P.floc && v.o[P.floc - 1] !== (st.floc ? D.flocOn : D.flocOff)) return false;
        return true;
      })[0];
    }
    function anyVariant() {
      return V.filter(function (v) {
        if (P.version && st.version && v.o[P.version - 1] !== st.version) return false;
        if (P.floc && v.o[P.floc - 1] !== (st.floc ? D.flocOn : D.flocOff)) return false;
        return true;
      })[0] || V[0];
    }

    var priceEl = $('[data-sdp-price]'), cmpEl = $('[data-sdp-compare]'), offEl = $('[data-sdp-off]');
    var idInput = $('[data-sdp-id]'), addBtn = $('[data-sdp-add]'), addLabel = $('[data-sdp-add-label]');
    var nameIn = $('[data-sdp-name]'), numIn = $('[data-sdp-num]');
    var propName = $('[data-sdp-prop-name]'), propNum = $('[data-sdp-prop-num]');
    var stockEl = $('[data-sdp-stock]'), stockTxt = $('[data-sdp-stock-txt]');
    var barSel = $('[data-sdp-bar-sel]'), barPrice = $('[data-sdp-bar-price]');
    var sizeLabel = $('[data-sdp-size-label]');
    var dyn = $('[data-sdp-dyn]');
    var currentVariant = null;

    function render() {
      var v = (P.size && st.size) ? find() : (P.size ? null : find());
      var shown = v || anyVariant();
      currentVariant = v;
      var unit = shown ? shown.p : 0;
      var total = unit + (st.patch ? st.patchPrice : 0);
      priceEl.textContent = money(total);
      if (shown && shown.c > shown.p) {
        cmpEl.textContent = money(shown.c + (st.patch ? st.patchPrice : 0)); cmpEl.hidden = false;
        offEl.textContent = '-' + Math.floor((shown.c - shown.p) * 100 / shown.c) + '%'; offEl.hidden = false;
      } else { cmpEl.hidden = true; offEl.hidden = true; }
      if (barPrice) barPrice.textContent = money(total);

      // tailles indisponibles
      $$('[data-sdp-opt="' + P.size + '"]').forEach(function (b) {
        var t = find(b.getAttribute('data-value'));
        b.classList.toggle('is-off', !t || !t.a);
      });

      if (v) idInput.value = v.id;
      var ready = !P.size || !!st.size;
      if (!ready) {
        addLabel.textContent = 'Choisis ta taille';
        addBtn.setAttribute('aria-disabled', 'true');
      } else if (!v || !v.a) {
        addLabel.textContent = 'Épuisé';
        addBtn.setAttribute('aria-disabled', 'true');
      } else {
        addLabel.textContent = 'Ajouter au panier · ' + money(total);
        addBtn.removeAttribute('aria-disabled');
      }
      if (dyn) dyn.style.display = (ready && v && v.a && !st.patch) ? '' : 'none';

      // stock
      if (stockEl) {
        var q = v ? v.q : null;
        stockEl.classList.remove('is-low', 'is-out');
        if (v && !v.a) { stockEl.classList.add('is-out'); stockTxt.textContent = 'Épuisé dans cette taille'; }
        else if (q !== null && q !== undefined && q > 0 && q <= D.lowStock) { stockEl.classList.add('is-low'); stockTxt.textContent = 'Plus que ' + q + ' en stock dans cette taille'; }
        else { stockTxt.textContent = 'En stock'; }
      }

      // propriétés de flocage
      var nm = nameIn ? nameIn.value.trim() : '', nb = numIn ? numIn.value.trim() : '';
      if (propName) { propName.value = nm; propName.disabled = !(st.floc && nm); }
      if (propNum) { propNum.value = nb; propNum.disabled = !(st.floc && nb); }

      var parts = [];
      if (st.version) parts.push(/player|joueur/i.test(st.version) ? 'Player' : 'Fan');
      parts.push(st.size || PH);
      if (st.floc) parts.push('floqué');
      if (barSel) barSel.textContent = parts.join(' · ');
      if (sizeLabel) sizeLabel.textContent = st.size || PH;
      updatePack();
    }

    /* ---------- options ---------- */
    $$('[data-sdp-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = Number(b.getAttribute('data-sdp-opt'));
        $$('[data-sdp-opt="' + pos + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (pos === P.size) {
          st.size = b.getAttribute('data-value');
          var hint = $('[data-sdp-size-hint]'); if (hint) hint.hidden = true;
          var sz = $('[data-sdp-sizes]'); if (sz) sz.classList.remove('is-alert');
          syncPackSizes();
        }
        if (pos === P.version) st.version = b.getAttribute('data-value');
        render();
      });
    });

    /* ---------- flocage ---------- */
    var flocToggle = $('[data-sdp-floc-toggle]'), flocFields = $('[data-sdp-floc-fields]'), custom = $('[data-sdp-custom]');
    var flocLayer = $('[data-sdp-floc]'), flocTag = $('[data-sdp-floc-tag]');
    var flocName = $('[data-sdp-floc-name]'), flocNum = $('[data-sdp-floc-num]');
    var lastSlide = $$('[data-sdp-slide]').length - 1;
    (function () {
      var extra = $('[data-sdp-floc-extra]');
      if (!extra || !P.floc) return;
      var on = V.filter(function (v) { return v.o[P.floc - 1] === D.flocOn; })[0];
      var off = on && V.filter(function (v) { return v.o[P.floc - 1] === D.flocOff && v.o.every(function (x, i) { return i === P.floc - 1 || x === on.o[i]; }); })[0];
      if (on && off && on.p > off.p) extra.textContent = '+' + money(on.p - off.p).replace(',00', '');
    })();
    function setFloc(on) {
      st.floc = on;
      if (flocToggle) flocToggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (flocFields) flocFields.hidden = !on;
      if (custom) custom.classList.toggle('is-on', on);
      if (flocLayer) flocLayer.hidden = !on;
      if (on && lastSlide > 0) goTo(lastSlide);
      if (on && nameIn) setTimeout(function () { nameIn.focus({ preventScroll: true }); }, 50);
      updateFlocTag();
      render();
    }
    if (flocToggle) flocToggle.addEventListener('click', function () { setFloc(!st.floc); });
    function updateFlocPreview() {
      if (flocName) flocName.textContent = (nameIn && nameIn.value.trim()) ? nameIn.value.trim().toUpperCase() : 'TON NOM';
      if (flocNum) flocNum.textContent = (numIn && numIn.value.trim()) ? numIn.value.trim() : '10';
    }
    if (nameIn) nameIn.addEventListener('input', function () { updateFlocPreview(); if (lastSlide > 0) goTo(lastSlide); render(); });
    if (numIn) numIn.addEventListener('input', function () { numIn.value = numIn.value.replace(/\D/g, '').slice(0, 2); updateFlocPreview(); if (lastSlide > 0) goTo(lastSlide); render(); });

    /* ---------- patchs ---------- */
    var patchToggle = $('[data-sdp-patch-toggle]'), patchList = $('[data-sdp-patch-list]'), patchName = $('[data-sdp-patch-name]');
    if (patchToggle) patchToggle.addEventListener('click', function () {
      var open = patchList.hidden; patchList.hidden = !open; patchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    st.patches = [];
    function syncPatches() {
      var on = $$('[data-sdp-patch]').filter(function (x) { return x.getAttribute('data-sdp-patch') && x.classList.contains('is-on'); });
      st.patches = on.map(function (x) { return Number(x.getAttribute('data-sdp-patch')); });
      st.patchPrice = on.reduce(function (a, x) { return a + (Number(x.getAttribute('data-price')) || 0); }, 0);
      st.patch = st.patches.length ? String(st.patches[0]) : '';
      var none = $('[data-sdp-patch=""]'); if (none) none.classList.toggle('is-on', !on.length);
      if (patchName) patchName.textContent = !on.length ? 'Aucun' : (on.length === 1 ? on[0].getAttribute('data-name') : on.length + ' patchs');
      $$('[data-sdp-patch]').forEach(function (x) { x.setAttribute('aria-pressed', x.classList.contains('is-on') ? 'true' : 'false'); });
    }
    $$('[data-sdp-patch]').forEach(function (o) {
      o.addEventListener('click', function () {
        if (!o.getAttribute('data-sdp-patch')) {
          $$('[data-sdp-patch]').forEach(function (x) { x.classList.remove('is-on'); });
          patchList.hidden = true; patchToggle.setAttribute('aria-expanded', 'false');
        } else {
          o.classList.toggle('is-on');
        }
        syncPatches();
        render();
      });
    });
    function patchItems() { return st.patches.map(function (id) { return { id: id, quantity: 1 }; }); }

    /* ---------- galerie ---------- */
    var slides = $('[data-sdp-slides]'), thumbs = $$('[data-sdp-thumb]'), dots = $$('[data-sdp-dot]');
    var curSlide = 0;
    function mark(i) {
      curSlide = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      updateFlocTag();
    }
    function goTo(i) {
      if (!slides) return;
      slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      mark(i);
    }
    function updateFlocTag() { if (flocTag) flocTag.hidden = !(st.floc && curSlide === lastSlide && lastSlide > 0); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-sdp-thumb'))); }); });
    if (slides) {
      var tm;
      slides.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () { var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); if (i !== curSlide) mark(i); }, 80);
      }, { passive: true });
    }

    /* ---------- panier ---------- */
    var errEl = $('[data-sdp-error]');
    function cartDrawer() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
    function addItems(items, btn) {
      var drawer = cartDrawer();
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
      }
      if (btn) btn.classList.add('is-loading');
      if (errEl) errEl.hidden = true;
      return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (!res.ok) { if (errEl) { errEl.textContent = res.j.description || "Impossible d'ajouter au panier."; errEl.hidden = false; } return; }
          if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
            var item = res.j.items ? res.j.items[0] : res.j;
            item.sections = res.j.sections;
            drawer.classList.remove('is-empty');
            drawer.renderContents(item);
          } else { window.location.href = base + 'cart'; }
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); window.location.href = base + 'cart'; });
    }
    function mainItem() {
      var it = { id: currentVariant.id, quantity: 1 };
      var nm = nameIn ? nameIn.value.trim() : '', nb = numIn ? numIn.value.trim() : '';
      if (st.floc && (nm || nb)) { it.properties = {}; if (nm) it.properties['Nom'] = nm; if (nb) it.properties['Numéro'] = nb; }
      return it;
    }
    function needSize() {
      if (P.size && !st.size) {
        var hint = $('[data-sdp-size-hint]'); if (hint) hint.hidden = false;
        var sz = $('[data-sdp-sizes]'); if (sz) { sz.classList.add('is-alert'); sz.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return true;
      }
      return false;
    }
    function mainAdd(btn) {
      if (needSize()) return;
      if (!currentVariant || !currentVariant.a) return;
      if (st.floc && nameIn && numIn && !nameIn.value.trim() && !numIn.value.trim()) { nameIn.focus(); if (errEl) { errEl.textContent = 'Indique un nom ou un numéro pour le flocage, ou décoche l’option.'; errEl.hidden = false; } return; }
      var items = [mainItem()];
      items = items.concat(patchItems());
      addItems(items, btn);
    }
    var form = $('.sdp__form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); mainAdd(addBtn); });
    var barBtn = $('[data-sdp-bar-btn]');
    if (barBtn) barBtn.addEventListener('click', function () { mainAdd(barBtn); });

    /* ---------- pack 3+1 ---------- */
    var rows = $$('[data-sdp-pack-row]');
    var packMsg = $('[data-sdp-pack-msg]'), packTotal = $('[data-sdp-pack-total]'), packFull = $('[data-sdp-pack-full]'), packAdd = $('[data-sdp-pack-add]');
    var packDots = $$('.sdp__pack-dots span');
    var sizeTouched = new WeakMap();
    rows.forEach(function (r) {
      try { r._v = JSON.parse(r.querySelector('[data-sdp-pack-json]').textContent); } catch (e) { r._v = []; }
      var chk = r.querySelector('[data-sdp-pack-check]'), sel = r.querySelector('[data-sdp-pack-size]');
      chk.addEventListener('click', function () { var on = chk.getAttribute('aria-pressed') !== 'true'; chk.setAttribute('aria-pressed', on ? 'true' : 'false'); r.classList.toggle('is-on', on); updatePack(); });
      sel.addEventListener('change', function () { sizeTouched.set(r, true); chk.setAttribute('aria-pressed', 'true'); r.classList.add('is-on'); updatePack(); });
    });
    function rowVariant(r) {
      var size = r.querySelector('[data-sdp-pack-size]').value;
      var sp = Number(r.dataset.sizePos), vp = Number(r.dataset.verPos), fp = Number(r.dataset.flocPos);
      return r._v.filter(function (v) {
        if (v.o[sp - 1] !== size) return false;
        if (vp && !/fan/i.test(v.o[vp - 1])) return false;
        if (fp && /avec/i.test(v.o[fp - 1])) return false;
        return true;
      })[0];
    }
    function syncPackSizes() {
      rows.forEach(function (r) {
        if (sizeTouched.get(r)) return;
        var sel = r.querySelector('[data-sdp-pack-size]');
        if ([].some.call(sel.options, function (o) { return o.value === st.size; })) sel.value = st.size;
      });
    }
    function updatePack() {
      if (!rows.length || !packTotal) return;
      var main = currentVariant || anyVariant();
      var prices = [main ? main.p : 0];
      rows.forEach(function (r) { if (r.classList.contains('is-on')) { var v = rowVariant(r); if (v) prices.push(v.p); } });
      var n = prices.length, sum = prices.reduce(function (a, b) { return a + b; }, 0);
      var free = n >= 4 ? Math.min.apply(null, prices) : 0;
      packTotal.textContent = money(sum - free);
      if (free) { packFull.textContent = money(sum); packFull.hidden = false; } else { packFull.hidden = true; }
      var left = 4 - n;
      packMsg.textContent = n >= 4 ? 'Pack complet : le moins cher est offert' : 'Ajoute encore ' + left + ' maillot' + (left > 1 ? 's' : '') + ', le 4ᵉ est offert';
      packDots.forEach(function (d, i) { d.classList.toggle('is-on', i < n); });
      packAdd.textContent = n > 1 ? 'Ajouter les ' + n + ' maillots' : 'Ajouter';
    }
    if (packAdd) packAdd.addEventListener('click', function () {
      if (needSize()) return;
      if (!currentVariant || !currentVariant.a) return;
      var items = [mainItem()];
      items = items.concat(patchItems());
      rows.forEach(function (r) { if (r.classList.contains('is-on')) { var v = rowVariant(r); if (v && v.a) items.push({ id: v.id, quantity: 1 }); } });
      addItems(items, packAdd);
    });

    /* ---------- livraison estimée ---------- */
    var eta = $('[data-sdp-eta]');
    if (eta) {
      var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
      var fmt = function (d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var now = new Date();
      var a = addBiz(now, Number(eta.dataset.min) || 8), b = addBiz(now, Number(eta.dataset.max) || 12);
      eta.innerHTML = 'Livraison offerte · reçu entre le <b>' + fmt(a) + '</b> et le <b>' + fmt(b) + '</b>';
    }

    /* ---------- barre mobile ---------- */
    var bar = $('[data-sdp-bar]'), buy = $('[data-sdp-buy]');
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = past ? 0 : -1;
      }).observe(buy);
    }

    render();
  
}
function boot() { document.querySelectorAll('[data-sdp]').forEach(initSdp); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
